<div class="overLayDiv active" style="z-index: 10001;">
    <div id="rightSideBar">
        <div class="rightSidePanel active w-95pc" style="z-index: 10001;">
            <header class="panel-header">
                <div class="viewDemo title-and-video">
                    <h2>{{ 'label_Step' | translate}} 2 - {{ "grade_wizard_text7" | translate }}</h2>
                    <app-video-icon [VideoUrl]="howDoIVideoLinks.ImportGrades | safeUrl"></app-video-icon>
                </div>
                <div class="panel-left-btn">
                    <button type="button" class="btn eod-btn-outline-warning mr-2" (click)="fnExportSampleFile()">
                        {{ "download_the_import_template" | translate }}
                    </button>
                    <button type="button" class="btn eod-btn-outline-warning mr-2" (click)="fnExportGrades()">
                        {{ "grade_wizard_text8" | translate }} 
                    </button>
                    <button type="button" class="btn eod-btn-primary mr-2" (click)="fnImportEmployees()">
                        {{ "grade_wizard_text9" | translate }}
                    </button>
                    <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                        {{ "close" | translate }}
                    </button>
                </div>
            </header>
            <div class="block mt-2 heightCalc-5">
                <div class="row"> 
                    <div class="col-lg-12 px-0">
                        <div class="heightCalc-14">
                            <!----------------------Start Grid--------------------------->
                            <app-grid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems"></app-grid>
                            <!----------------------End Grid--------------------------->
                        </div>
                    </div>
                    <div class="col-md-12 mt-5 pt-2 d-flex justify-content-center">
                        <button type="button" class="btn eod-btn-primary" (click)="fnShowImportInstuctionPanel()">
                            {{ "import_instructions_read" | translate }}
                        </button>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</div>

<!----------------------Side Panels------------------------------------->
<div class="overLayDiv active" style="z-index: 10005;" *ngIf="showImportInstuctionPanel">
    <div id="rightSideBar">
        <div class="rightSidePanel active" style="z-index: 10005;">
            <header class="panel-header">
                <div class="viewDemo title-and-video">
                    <h2>{{ "import_instructions_read" | translate }}</h2>
                </div>            
                <div class="panel-left-btn">
                    <button type="button" class="btn eod-btn-outline-warning" (click)="fnCloseImportInstuctionPanel()">
                        {{ "close" | translate }}
                    </button>
                </div>
            </header>
            <div class="block mt-2">
                <h6 class="info-text">
                    <span class="pr-2">1.</span>
                    <span>{{ "grade_import_msg20" | translate }}</span>
                </h6>
                <h6 class="info-text">
                    <span class="pr-2">2.</span>
                    <span>{{ "grade_import_msg21" | translate }}</span>
                </h6>
                <h6 class="info-text">
                    <span class="pr-2">3.</span>
                    <span>{{ "grade_import_msg22" | translate }}</span>
                </h6>
                <h6 class="info-text">
                    <span class="pr-2">4.</span>
                    <span>{{ "grade_import_msg23" | translate }}</span>
                </h6>
            </div>
        </div>
    </div>
</div>